import { createFileRoute } from "@tanstack/react-router";
import { AnexosPage } from "@/paginas/anexos";

export const Route = createFileRoute("/_authenticated/anexos")({
  head: () => ({
    meta: [
      { title: "Anexos — Milky Moo Palmares" },
      {
        name: "description",
        content: "Listagem de todos os arquivos anexados na aplicação, com download e exclusão.",
      },
      { property: "og:title", content: "Anexos — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Listagem de todos os arquivos anexados na aplicação, com download e exclusão.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: AnexosPage,
});
